import { tv } from "@/utils/tv.config";
import type { VariantProps } from "tailwind-variants";

export const dividerClasses = tv({
  base: "Divider__root shrink-0 bg-gray-300 border-none",
  variants: {
    orientation: {
      horizontal: "Divider__horizontal w-full h-[1px] my-2",
      vertical: "Divider__vertical min-h-full h-auto w-[1px] mx-2",
    },
  },
  defaultVariants: {
    orientation: "horizontal",
  },
});

export type DividerVariantProps = VariantProps<typeof dividerClasses>;
